import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

import { getContextGraphs } from '@/services/context-graphs/get-context-graphs';
import { useOrgStore } from '@/stores/org-store';

export const contextGraphsKey = (orgId: string | null) => [
  'context-graphs',
  orgId,
];

export const useContextGraphs = () => {
  const orgId = useOrgStore((state) => state.currentOrg?.orgid ?? null);

  return useQuery({
    queryKey: contextGraphsKey(orgId),
    queryFn: async () => {
      try {
        return await getContextGraphs();
      } catch (error) {
        Sentry.captureException(error, {
          extra: { context: 'list-context-graphs', orgId },
        });
        throw error;
      }
    },
    enabled: Boolean(orgId),
  });
};
